let result;

export const getFaqWidget = () => {
  if (result) return Promise.resolve(result);
  return import('./widget-faq').then((module) => {
    result = module;
    return module;
  });
};